
















































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import CatatanKebidananSvc from "@/services/CatatanKebidanan";
import { TEMPLATE_TINDAKAN } from "./templateTindakanKebidanan";
import {
  DIAGNOSA_SPEC,
  faseOptions,
  composeDiagnosa,
  parseDiagnosa,
  parseDiagnosaLenient,
  hasAnyValue,
  ABORTUS_FASE,
  FASE_LAINNYA,
  FASE_LAINNYA_STORED,
  DxSeg,
  DxValues
} from "@/utils/diagnosaKebidanan";
import { SUBTIPE_LABELS } from "@/utils/abortusSubtipe";
import http from "@/axios/http-common";
import { fetchApgarBbl } from "@/utils/apgarBbl";

interface TindakanItem {
  kode_tindakan: string;
  nama_tindakan: string;
  dilakukan: boolean;
  jam_dilakukan: string | null;
  keterangan: string | null;
}

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardCatatanKebidananInput extends Vue {
  @Prop() register!: any;
  @Prop() rm!: any;
  @Prop({ default: null }) editData!: any;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = false;
  saving = false;
  menuDate = false;
  customTindakan = "";

  // Dokter list (for Kolaborasi dr. Sp.OG)
  dokterSearch = "";
  dokterList: any[] = [];
  dokterLoading = false;

  // Bidan list
  bidanSearch = "";
  bidanList: any[] = [];
  bidanLoading = false;

  form: any = {
    tanggal: localISODate(),
    shift: null,
    fase: null,
    g: null,
    p: null,
    a: null,
    ah: null,
    uk_minggu: null,
    uk_hari: null,
    hari_ke: null,
    durasi: null,
    satuan: null,
    penyerta: "",
    keterangan: "",
    dx_bebas: "",
    diagnosis_subtipe: null,
    bayi_lahir_jam: null,
    bayi_jk: null,
    bayi_bbl: null,
    bayi_apgar: null,
    plasenta_lahir_jam: null,
    plasenta_kesan: null,
    kolaborasi_dengan: "",
    catatan_tambahan: "",
    bidan_user_id: null as number | null,
    tindakan: [] as TindakanItem[]
  };

  faseItems = faseOptions();

  get isLainnya(): boolean {
    return this.form.fase === FASE_LAINNYA;
  }

  get activeSpec() {
    return this.form.fase ? DIAGNOSA_SPEC[this.form.fase] || null : null;
  }

  get activeSegments(): DxSeg[] {
    const spec = this.activeSpec;
    if (!spec) return [];
    return spec.segments.filter(s => s.t !== "lit");
  }

  get composedDiagnosa(): string {
    if (this.isLainnya) return String(this.form.dx_bebas || "").trim();
    if (!this.activeSpec) return "";
    return composeDiagnosa(this.form.fase, this.form as DxValues);
  }

  fieldCols(s: DxSeg): number {
    if (s.t === "lit" || s.t === "text") return 12;
    return ["g", "p", "a", "ah"].indexOf(s.key) !== -1 ? 2 : 3;
  }

  get isEdit() {
    return this.editData && this.editData.id;
  }

  get canSave(): boolean {
    if (this.readOnly) return false;
    if (!this.composedDiagnosa) return false;
    const action = this.isEdit ? "edit" : "create";
    return userModule.canAccessForm("catatan_kebidanan", action);
  }

  get formattedDate() {
    if (!this.form.tanggal) return "";
    const d = new Date(this.form.tanggal);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  get tindakanDilakukanCount() {
    return this.form.tindakan.filter((t: TindakanItem) => t.dilakukan).length;
  }

  get isAbortus(): boolean {
    if (this.isLainnya) {
      return /abortus/i.test(String(this.form.dx_bebas || ""));
    }
    return ABORTUS_FASE.indexOf(this.form.fase) !== -1;
  }

  get subtipeOptions() {
    return Object.keys(SUBTIPE_LABELS).map(key => ({
      text: (SUBTIPE_LABELS as Record<string, string>)[key],
      value: key
    }));
  }

  mounted() {
    this.loadDokterList();
    this.loadBidanList();
    // Default bidan ke user yang login
    const user = userModule.user;
    if (user?.id) {
      this.form.bidan_user_id = user.id;
    }
    if (this.isEdit) {
      this.populateEditData();
    }
  }

  @Watch("editData")
  onEditDataChange() {
    if (this.isEdit) {
      this.populateEditData();
    } else {
      this.resetForm();
    }
  }

  populateEditData() {
    const d = this.editData;
    this.form.tanggal = d.tanggal ? d.tanggal.substr(0, 10) : localISODate();
    this.form.shift = d.shift;
    this.form.diagnosis_subtipe = d.diagnosis_subtipe || null;
    this.hydrateDiagnosa(d.fase, d.diagnosa_kebidanan);
    this.form.bayi_lahir_jam = d.bayi_lahir_jam;
    this.form.bayi_jk = d.bayi_jk;
    this.form.bayi_bbl = d.bayi_bbl;
    this.form.bayi_apgar = d.bayi_apgar;
    this.form.plasenta_lahir_jam = d.plasenta_lahir_jam;
    this.form.plasenta_kesan = d.plasenta_kesan;
    this.form.kolaborasi_dengan = d.kolaborasi_dengan || "";
    this.form.catatan_tambahan = d.catatan_tambahan || "";
    this.form.bidan_user_id = d.bidan_user_id || null;

    // Populate tindakan from existing data
    if (d.tindakan && d.tindakan.length) {
      this.form.tindakan = d.tindakan.map((t: any) => ({
        kode_tindakan: t.kode_tindakan,
        nama_tindakan: t.nama_tindakan,
        dilakukan: t.dilakukan,
        jam_dilakukan: t.jam_dilakukan ? t.jam_dilakukan.substr(0, 5) : null,
        keterangan: t.keterangan || null
      }));
    }
  }

  hydrateDiagnosa(fase: string, dx: unknown) {
    const text = typeof dx === "string" ? dx : "";
    const spec = fase ? DIAGNOSA_SPEC[fase] : null;

    if (spec) {
      let values: DxValues | null = parseDiagnosa(fase, text);
      if (!values) {
        const lenient = parseDiagnosaLenient(text);
        if (hasAnyValue(lenient)) values = lenient;
      }
      if (values) {
        const vals: Record<string, string | number | null> = values;
        this.form.fase = fase;
        Object.keys(vals).forEach(k => {
          this.form[k] = vals[k];
        });
        this.syncTindakanTemplate(fase);
        return;
      }
    }

    this.form.fase = FASE_LAINNYA;
    this.form.dx_bebas = text;
  }

  syncTindakanTemplate(fase: string) {
    const template = TEMPLATE_TINDAKAN[fase] || [];
    this.form.tindakan = template.map((t: any) => ({
      kode_tindakan: t.kode,
      nama_tindakan: t.nama,
      dilakukan: false,
      jam_dilakukan: null,
      keterangan: null
    }));
  }

  async onFaseChange(fase: string) {
    if (!this.isAbortus) {
      this.form.diagnosis_subtipe = null;
    }
    if (!fase) return;

    this.syncTindakanTemplate(fase);

    if (fase !== "kala2") {
      this.form.bayi_lahir_jam = null;
      this.form.bayi_jk = null;
      this.form.bayi_bbl = null;
      this.form.bayi_apgar = null;
    }
    if (fase !== "kala3") {
      this.form.plasenta_lahir_jam = null;
      this.form.plasenta_kesan = null;
    }
    // IMP-066: prefill APGAR bayi dari Asesmen BBL saat fase kala II (bila kosong)
    if (fase === "kala2" && !this.form.bayi_apgar) {
      const a = await fetchApgarBbl(this.register);
      if (a) {
        const parts = [a.apgar_1, a.apgar_5, a.apgar_10].filter(
          v => v !== null && v !== undefined
        );
        if (parts.length) this.form.bayi_apgar = parts.join("/");
      }
    }
  }

  addCustomTindakan() {
    if (!this.customTindakan.trim()) return;

    const idx = this.form.tindakan.length + 1;
    this.form.tindakan.push({
      kode_tindakan: `custom_${idx}`,
      nama_tindakan: this.customTindakan.trim(),
      dilakukan: true,
      jam_dilakukan: null,
      keterangan: null
    });
    this.customTindakan = "";
  }

  async loadDokterList() {
    this.dokterLoading = true;
    try {
      const res = await http.getData("/combo/dokter");
      this.dokterList = (res.data || []).map((d: any) => ({ user_id: d.user_id, nama: d.nama }));
    } catch {
      this.dokterList = [];
    }
    this.dokterLoading = false;
  }

  async loadBidanList() {
    this.bidanLoading = true;
    try {
      const res = await http.getData("/combo/perawat");
      this.bidanList = (res.data || []).map((d: any) => ({ user_id: d.id, nama: d.nama }));
    } catch {
      this.bidanList = [];
    }
    this.bidanLoading = false;
  }

  async save() {
    if (this.readOnly) return;
    const formRef = this.$refs.form as any;
    if (formRef && !formRef.validate()) return;

    const diagnosa = this.composedDiagnosa;
    if (!diagnosa) return;

    this.saving = true;
    const regNo = typeof this.register === "object" ? this.register.no : this.register;
    const pasienRm = typeof this.rm === "object" ? this.rm : this.rm;

    const payload = {
      register_id: regNo,
      pasien_rm: String(pasienRm),
      tanggal: this.form.tanggal,
      shift: this.form.shift,
      fase: this.isLainnya ? FASE_LAINNYA_STORED : this.form.fase,
      diagnosa_kebidanan: diagnosa,
      diagnosis_subtipe: this.isAbortus ? this.form.diagnosis_subtipe : null,
      bayi_lahir_jam: this.form.fase === "kala2" ? this.form.bayi_lahir_jam : null,
      bayi_jk: this.form.fase === "kala2" ? this.form.bayi_jk : null,
      bayi_bbl: this.form.fase === "kala2" ? this.form.bayi_bbl : null,
      bayi_apgar: this.form.fase === "kala2" ? this.form.bayi_apgar : null,
      plasenta_lahir_jam: this.form.fase === "kala3" ? this.form.plasenta_lahir_jam : null,
      plasenta_kesan: this.form.fase === "kala3" ? this.form.plasenta_kesan : null,
      kolaborasi_dengan: this.form.kolaborasi_dengan || null,
      catatan_tambahan: this.form.catatan_tambahan || null,
      bidan_user_id: this.form.bidan_user_id || userModule.user?.id,
      tindakan: this.form.tindakan.map((t: TindakanItem) => ({
        kode_tindakan: t.kode_tindakan,
        nama_tindakan: t.nama_tindakan,
        dilakukan: t.dilakukan,
        jam_dilakukan: t.dilakukan && t.jam_dilakukan ? t.jam_dilakukan.substr(0, 5) : null,
        keterangan: t.dilakukan ? t.keterangan : null
      }))
    };

    try {
      if (this.isEdit) {
        await CatatanKebidananSvc.update(this.editData.id, payload);
      } else {
        await CatatanKebidananSvc.create(payload);
      }
      this.resetForm();
      this.$emit("saved");
    } catch (e) {
      // error handled by service
    } finally {
      this.saving = false;
    }
  }

  cancel() {
    this.resetForm();
    this.$emit("cancel");
  }

  resetForm() {
    this.form = {
      tanggal: localISODate(),
      shift: null,
      fase: null,
      g: null,
      p: null,
      a: null,
      ah: null,
      uk_minggu: null,
      uk_hari: null,
      hari_ke: null,
      durasi: null,
      satuan: null,
      penyerta: "",
      keterangan: "",
      dx_bebas: "",
      diagnosis_subtipe: null,
      bayi_lahir_jam: null,
      bayi_jk: null,
      bayi_bbl: null,
      bayi_apgar: null,
      plasenta_lahir_jam: null,
      plasenta_kesan: null,
      kolaborasi_dengan: "",
      catatan_tambahan: "",
      bidan_user_id: userModule.user?.id || null,
      tindakan: []
    };
    this.customTindakan = "";
    const formRef = this.$refs.form as any;
    if (formRef) formRef.resetValidation();
  }
}
